import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Checkout.css";
import { PaymentForm, CreditCard } from "react-square-web-payments-sdk";
import { useCart } from "../context/CartContext";

const Checkout = () => {
  const { getCartTotal } = useCart();
  const [paymentStatus, setPaymentStatus] = useState("");

  const totalInCents = Math.round(getCartTotal() * 100);

  const handlePayment = async (tokenResult) => {
    setPaymentStatus("Processing payment...");
    try {
      const response = await fetch("/api/pay", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: tokenResult.token,
          amount: totalInCents,
        }),
      });
      const data = await response.json();
      if (data.success) {
        setPaymentStatus("Payment successful! Thank you for your purchase.");
      } else {
        setPaymentStatus(`Payment failed: ${data.error?.[0]?.detail || "unknown error"}`);
      }
    } catch (err) {
      setPaymentStatus("Error processing payment. Please try again later.");
    }
  };

  return (
    <section className="checkout-page">
      <div className="checkout-container">
        <h1>Secure Checkout</h1>
        <p className="checkout-subtitle">Total: ${getCartTotal().toFixed(2)}</p>
        {paymentStatus && <div className="payment-message">{paymentStatus}</div>}
        <PaymentForm
          applicationId="YOUR_SQUARE_APPLICATION_ID"
          locationId="YOUR_SQUARE_LOCATION_ID"
          cardTokenizeResponseReceived={handlePayment}
        >
          <CreditCard />
        </PaymentForm>
        <Link to="/cart" className="button return-btn">Return to Cart</Link>
      </div>
    </section>
  );
};

export default Checkout;
